import type { Layout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

import { LazyCsmSupportWidget } from './LazyCsmSupportWidget.tsx';

export const csmWidgetLayout: Layout = {
	globalComponents: [LazyCsmSupportWidget],
	rightSidebars: [],
	isChromeless: false,
};
